export class ErrorType {
    code: number;
    title: string;
    errors: Array<string>;

    constructor() {
        this.code = 0;
        this.title = '';
        this.errors = [];
    }

    public errorsToString(): string {
        if (!this.errors) {
            return '';
        }

        return this.errors.join('\n');
    }
}
